import { useEffect } from "react";
import type { useReactFlow } from "reactflow";

interface Params {
  flow: ReturnType<typeof useReactFlow>;
  setSelectedNodeId: (id: string | null) => void;
}

export function useCanvasFocusEvents({ flow, setSelectedNodeId }: Params) {
  useEffect(() => {
    function focusNode(e: Event) {
      const id = (e as CustomEvent<{ nodeId?: string }>).detail?.nodeId;
      if (!id) return;
      const node = flow.getNode(id);
      if (node) flow.setCenter(node.position.x, node.position.y, { zoom: 1.2, duration: 300 });
    }
    function focusMachine(e: Event) {
      const detail = (e as CustomEvent<{ id?: string }>).detail;
      if (!detail?.id) return;
      const target = flow
        .getNodes()
        .find(
          (n) => n.type === "MACHINE" && (n.data as { machineId?: string })?.machineId === detail.id
        );
      if (target) {
        flow.setCenter(target.position.x, target.position.y, { zoom: 1.2, duration: 300 });
      }
    }
    function selectNode(e: Event) {
      const id = (e as CustomEvent<{ nodeId?: string }>).detail?.nodeId;
      if (!id) return;
      requestAnimationFrame(() => {
        setSelectedNodeId(id);
        const node = flow.getNode(id);
        if (node) flow.setCenter(node.position.x, node.position.y, { zoom: 1.2, duration: 300 });
      });
    }
    window.addEventListener("opus:editor:focus-node", focusNode);
    window.addEventListener("opus:editor:focus-machine", focusMachine);
    window.addEventListener("opus:editor:select-node", selectNode);
    return () => {
      window.removeEventListener("opus:editor:focus-node", focusNode);
      window.removeEventListener("opus:editor:focus-machine", focusMachine);
      window.removeEventListener("opus:editor:select-node", selectNode);
    };
  }, [flow, setSelectedNodeId]);
}
